import classNames from 'classnames';
import * as React from 'react';

export interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    invalid?: boolean;
    muted?: boolean;
}

export const TextInput: React.FunctionComponent<TextInputProps> = ({invalid, muted, className, ...rest}: TextInputProps) => (
    <input className={classNames('mp-input', {'mp-input--invalid': invalid, 'mp-input--muted': muted}, className)} {...rest}/>
);
